import ReactTooltip from "react-tooltip";
import styled, { css } from "styled-components";

export default styled(ReactTooltip)`
  ${({ theme }) => css`
    span {
      white-space: normal;
    }
    &.__react_component_tooltip {
      text-align: left;
      max-width: 300px;

      &.type-dark {
        background: ${theme.colors.primaryDark};

        &.place-left {
          &:after {
            border-left-color: ${theme.colors.primaryDark};
          }
        }

        &.place-top: {
          &:after {
            border-top-color: ${theme.colors.primaryDark};
          }
        }

        &.place-right: {
          &:after {
            border-right-color: ${theme.colors.primaryDark};
          }
        }

        &.place-bottom: {
          &:after {
            border-bottom-color: ${theme.colors.primaryDark};
          }
        }
      }

      &.type-light {
        background: ${theme.colors.primaryLight};

        &.place-left {
          &:after {
            border-left-color: ${theme.colors.primaryLight};
          }
        }

        &.place-top: {
          &:after {
            border-top-color: ${theme.colors.primaryLight};
          }
        }

        &.place-right: {
          &:after {
            border-right-color: ${theme.colors.primaryLight};
          }
        }

        &.place-bottom: {
          &:after {
            border-bottom-color: ${theme.colors.primaryLight};
          }
        }
      }

      &.type-error {
        background: ${theme.colors.error};

        &.place-left {
          &:after {
            border-left-color: ${theme.colors.error};
          }
        }

        &.place-top: {
          &:after {
            border-top-color: ${theme.colors.error};
          }
        }

        &.place-right: {
          &:after {
            border-right-color: ${theme.colors.error};
          }
        }

        &.place-bottom: {
          &:after {
            border-bottom-color: ${theme.colors.error};
          }
        }
      }

      &.type-warning {
        background: ${theme.colors.warn};

        &.place-left {
          &:after {
            border-left-color: ${theme.colors.warn};
          }
        }

        &.place-top: {
          &:after {
            border-top-color: ${theme.colors.warn};
          }
        }

        &.place-right: {
          &:after {
            border-right-color: ${theme.colors.warn};
          }
        }

        &.place-bottom: {
          &:after {
            border-bottom-color: ${theme.colors.warn};
          }
        }
      }

      &.type-success {
        background: ${theme.colors.success};

        &.place-left {
          &:after {
            border-left-color: ${theme.colors.success};
          }
        }

        &.place-top: {
          &:after {
            border-top-color: ${theme.colors.success};
          }
        }

        &.place-right: {
          &:after {
            border-right-color: ${theme.colors.success};
          }
        }

        &.place-bottom: {
          &:after {
            border-bottom-color: ${theme.colors.success};
          }
        }
      }
    }
  `}
`;
